skrilla.directive('profileTag',function() {
    return {
        templateUrl: 'directives/profileTag/profileTag.html',
        scope: {
            prefixText: "=",
            newTab: "=",
            username: "=",
            tags: "=",
            isLink: "=",
            id: "="   //userId
        },
        controller: function($scope, profileTagService){
            $scope.colour = function(tag){
                if(tag !== undefined){
                    return profileTagService.getTag(tag).colour;
                }
            }
            $scope.toolTipText = function(tag){
                if(tag !== undefined){
                    return profileTagService.getTag(tag).title;
                }
            }
            $scope.openNewTab = function (newTab) {
                return newTab ? '_blank' : ''
            }
        }
    };
});
